<template>
  <v-tabs
    v-model="tab"
    background-color="colorDominant colorTabs"
    :icons-and-text="isCredit2"
    show-arrows
    grow
    centered
  >
    <v-tabs-slider class="c-tab-slider"></v-tabs-slider>

    <template v-for="item in menuItems">
      <v-tab
        :key="item.label"
        v-show="item.show"
        @click="
          $router
            .push(
              item.route.name === 'liveCasino'
                ? dataRouteLiveCasino
                : item.route
            )
            .catch(() => {})
        "
        class="white--text text-capitalize text-uppercase"
        :style="isCredit2 ? 'font-size:10px; line-height: 20px' : ''"
      >
        <div v-if="item.isWorldCup" class="d-flex flex-column align-center">
          <v-img
            src="https://dozr8la71aog.cloudfront.net/domains/betdasorte/img/custom/icons/sports/54_small.png"
            style="width: 25px; border-radius: 50%"
          />

          {{ item.label }}
        </div>
        <template v-else-if="item.icon_img">
          <span
            style="line-height: 1.5em"
            :class="
              !$permissions().customIcons.appbar ? '' : 'font-weight-bold'
            "
            >{{ item.label }}</span
          >
          <img
            v-if="!$permissions().customIcons.appbar"
            class="mb-0"
            width="22px"
            :src="item.icon_img"
          />
          <img v-else class="mb-0" width="28px" :src="item.icon_img" />
        </template>
        <template v-else>
          <span :class="isCredit2 ? 'order-1' : 'order-2'">{{
            item.label
          }}</span>
          <v-icon
            class="mb-0"
            :class="[item.class, isCredit2 ? 'order-2' : 'order-1']"
            size="22"
            :left="!isCredit2"
            >{{ item.icon }}</v-icon
          >
        </template>
      </v-tab>
    </template>
  </v-tabs>
</template>
<script>
import mainMenu from "@/util/main-menu.js";
export default {
  name: "mobile-tabs-component",
  props: ["logged"],
  data: () => ({
    menuItems: [],
    tab: 0,
  }),
  mounted() {
    this.menuItems = mainMenu();
    this.tabsValues(this.$route);
  },
  computed: {
    isCredit2() {
      return this.$store.state.operators.credit === "2";
    },
    dataRouteLiveCasino() {
      return {
        path: `/casino/listGamesCategories/${this.$t("liveCasino")}`,
        hash: "#scrollTop",
      };
    },
  },
  watch: {
    "$route.query.event"() {
      this.tabsValues(this.$route);
    },
    $route(val) {
      this.tabsValues(val);
    },
    logged(val) {
      // Se o usuário logar, recarregar o menu novamente
      // para mostrar a aba "apostas";
      if (val) {
        this.menuItems = mainMenu();

        const showWorldCup = ["cartola", "dasorte", "betdasorte"];

        this.menuItems.forEach((item) => {
          if (
            item.route.name === "worldCup" &&
            showWorldCup.includes(this.$domain()) &&
            this.$store.state.sports.find((sport) => sport.id_sport == 100)
          ) {
            item.show = !this.$isAgent() && this.isCredit2;
          } else if (item.route.name === "worldCupWinner") {
            const worldCupWinnerSportId = 51;
            const sports = this.$store.state.sports;
            let hasLongTerm = false;

            if (sports) {
              if (
                sports.find((sport) => sport.id_sport == worldCupWinnerSportId)
              ) {
                hasLongTerm = true;
              }
            }

            item.show = !this.$isAgent() && this.isCredit2 && hasLongTerm;
          }
        });
      }
    },
  },
  methods: {
    tabsValues(route) {
      this.menuItems.forEach((item, index) => {
        var routeName =
          item.route.name === route.name &&
          !this.$route.path.includes("/casino");
        var routePath = route.path.split("/")[1] === item.route.name;
        var routePathQuery =
          route.path.split("/")[1] === item.route.name &&
          route.name === "casinoSpaceman" &&
          route.query.gameSearch === "spaceman";
        // var routeLiveCasino =
        //   item.route.name === "liveCasino" &&
        //   route.params.category === this.$t("liveCasino");

        let activeCasino = false;

        if (item.route.params) {
          if (this.$route.path.includes("/casino")) {
            activeCasino =
              this.$route.params.casinoType === item.route.params.casinoType;
          }
        }

        let isWorldCupRoute = false;

        if (item.isWorldCup) {
          if (this.$route.query.event == item.route.query.event) {
            isWorldCupRoute = true;
            this.tab = index;
          }

          return;
        }

        if (
          isWorldCupRoute ||
          routeName ||
          (routePath && !routePathQuery) ||
          routePathQuery ||
          activeCasino
        ) {
          this.tab = index;
        }
      });
    },
  },
};
</script>
